<template>
  <div>
    <router-link
      tag="button"
      class="btn btn-primary mr-2 mt-2 card flex-grow w-100"
      to="/"
    >
      <div class="d-flex align-items-center" style="min-height: 38px">
        <img width="24" src="../../assets/nav-icons/home.svg" class="mx-2" />
        <span class="pt-2">Home</span>
      </div>
    </router-link>

    <router-link
      tag="button"
      class="btn btn-primary mr-2 mt-2 card flex-grow w-100"
      to="/scenarios"
    >
      <div class="d-flex align-items-center" style="min-height: 38px">
        <img width="24" src="../../assets/nav-icons/health.svg" class="mx-2" />
        <span class="pt-2">Scenarios</span>
      </div>
    </router-link>

    <router-link
      v-if="user.canProvision && isOnNative"
      tag="button"
      class="btn btn-primary mr-2 mt-2 card flex-grow w-100"
      to="/me/provisioning"
    >
      <div class="d-flex align-items-center" style="min-height: 38px">
        <i class="material-icons" style="margin-right: 7px">note</i>
        Licensing
      </div>
    </router-link>
    <router-link
      tag="button"
      class="btn btn-primary mr-2 mt-2 card flex-grow w-100"
      to="/tms"
    >
      <div class="d-flex align-items-center" style="min-height: 38px">
        <img width="24" src="../../assets/nav-icons/tms.svg" class="mx-2" />
        TMS
      </div>
    </router-link>
    <DeviceInformation
      v-if="user.canProvision && isOnNative"
    ></DeviceInformation>
    <NotificationDropdown v-if="user"></NotificationDropdown>
    <LoggedInUser
      v-if="user"
      :user="user.first_name + ' ' + user.last_name"
    ></LoggedInUser>
  </div>
</template>

<script>
import NotificationDropdown from "./NotificationDropdown.vue";
import LoggedInUser from "./LoggedInUser.vue";
import DeviceInformation from "./DeviceInformation.vue";

export default {
  name: "NavCollapsedButtons",
  components: {
    LoggedInUser,
    NotificationDropdown,
    DeviceInformation,
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
  },
};
</script>

<style scoped></style>
